import { IonAvatar, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonContent, IonHeader, IonIcon, IonLabel, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import './Tab1.css';
import { location, shirt, helpBuoy, medkit } from 'ionicons/icons';

const Tab1: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        {/* <IonToolbar>
          <IonTitle>Zonate</IonTitle>
        </IonToolbar> */}
      </IonHeader>
        <IonContent className="ion-padding">
          <div className='middle'>
            <br/>
            <h1>Welcome to Zonate! 🍃</h1>
            <p>Discover meaningful ways to give back</p>
            <h3>Causes</h3>
              <IonChip className='filter green'>
                <IonIcon className='green' icon={shirt}></IonIcon>
                <IonLabel>Clothes</IonLabel>
              </IonChip>
              <IonChip className='filter green'>
                <IonIcon className='green' icon={helpBuoy}></IonIcon>
                <IonLabel>Disaster Relief</IonLabel>
              </IonChip>
              <IonChip className='filter salmon'>
                <IonIcon className='salmon' icon={medkit}></IonIcon>
                <IonLabel>Health & Wellness</IonLabel>
              </IonChip>
            <h3>Trending Causes</h3>
            <p><IonIcon className='green local' icon={location}></IonIcon> Near you</p>
            <hr className='hr'/>
          </div>

          <center>
          <IonCard className='lightGreen'> 
            <IonChip className='donation'>
              <IonLabel>Donation</IonLabel>
            </IonChip>
            <img className='tempImg' alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/card-media.png" />
            <IonCardHeader>
              <IonCardTitle>Woodside NY Charity Centre</IonCardTitle>
              <IonCardSubtitle>54-09, 32nd avenue, Brooklyn, NY, 11388</IonCardSubtitle>
              <IonCardContent>
                content
              </IonCardContent>
            </IonCardHeader>
          </IonCard>
          </center>
        </IonContent>
    </IonPage>
  );
};

export default Tab1;
